import { Stack, Redirect, useSegments } from "expo-router";
import { useAuth } from "@/context/AuthContext";
import { getPostLoginRedirectPath } from "@/lib/authRedirect";
/**
 * Auth group layout — redirects already-authenticated users away,
 * except for the change-password screen which requires authentication.
 */
export default function AuthLayout() {
  const { isAuthenticated, isLoading, user } = useAuth();
  const segments = useSegments();

  // Show nothing while restoring session — prevents a flash to login
  // before the token + user profile have been loaded from storage.
  if (isLoading) return null;

  if (isAuthenticated && user) {
    // Allow authenticated users with a temporary password to stay on the change-password screen
    if (user.temporaryPasswordSet) {
      const onChangePassword = segments.includes("change-password" as never);
      if (!onChangePassword) {
        return <Redirect href="/(auth)/change-password" />;
      }
      return <Stack screenOptions={{ headerShown: false }} />;
    }
    return <Redirect href={getPostLoginRedirectPath(user.roles, user.vendorStatus)} />;
  }
  return <Stack screenOptions={{ headerShown: false }} />;
}
